<template lang="pug">
div
    .padding.m-t-md
        .margin
            .pull-right.w-lg
                outlet-selector

            h5.m-b-0._300 Inventory Dashboard

        .row.m-t-md.p-t-sm
            .col-sm-6.col-md-3.col-xs-12
                .box.p-a
                    .pull-left.m-r
                        i.material-icons.text-primary.md-36.m-y-sm &#xE54E;
                    .clear
                        .text-muted.text-ellipsis Ideal Stock Count
                        h4.m-a-0.text-md._600
                            v-loading(loader="fetch-summary")
                                a(class="text-dark") {{ summary.total_ideal_stock }}

            .col-sm-6.col-md-3.col-xs-12
                .box.p-a
                    .pull-left.m-r
                        i.material-icons.text-danger.md-36.m-y-sm &#xE8E3;
                    .clear
                        .text-muted.text-ellipsis Low Stock Count
                        h4.m-a-0.text-md._600
                            v-loading(loader="fetch-summary")
                                a(class="text-dark") {{ summary.total_low_stock }}

            .col-sm-6.col-md-3.col-xs-12
                .box.p-a
                    .pull-left.m-r
                        i.material-icons.md-36.text-dark.m-y-sm assessment
                    .clear
                        .text-muted.text-ellipsis Stock Inventory
                        h4.m-a-0.text-md._600
                            v-loading(loader="fetch-summary")
                                a(class="text-dark") {{ summary.total_stock_inventory }}

            .col-sm-6.col-md-3.col-xs-12
                .box.p-a
                    .pull-left.m-r
                        i.material-icons.md-36.text-muted.m-y-sm table_chart
                    .clear
                        .text-muted.text-ellipsis End Product
                        h4.m-a-0.text-md._600
                            v-loading(loader="fetch-summary")
                                a(class="text-dark") {{ summary.total_stock_composite }}

            .col-sm-6.col-md-3.col-xs-12
                .box.p-a
                    .pull-left.m-r
                        i.material-icons.md-36.text-info.m-y-sm &#xE1BD;
                    .clear
                        .text-muted.text-ellipsis New Product
                        h4.m-a-0.text-md._600
                            v-loading(loader="fetch-summary")
                                a(class="text-dark") {{ summary.total_new_product }}

            .col-sm-6.col-md-3.col-xs-12
                .box.p-a
                    .pull-left.m-r
                        i.material-icons.md-36.text-warn.m-y-sm &#xE86C;
                    .clear
                        .text-muted.text-ellipsis Stock Check Activity This Month
                        h4.m-a-0.text-md._600
                            v-loading(loader="fetch-summary")
                                a(class="text-dark") {{ summary.total_check_activity }}

            .col-sm-6.col-md-3.col-xs-12
                .box.p-a
                    .pull-left.m-r
                        i.material-icons.md-36.text-success.m-y-sm &#xE8DD;
                    .clear
                        .text-muted.text-ellipsis Purchase Order Activity This Month
                        h4.m-a-0.text-md._600
                            v-loading(loader="fetch-summary")
                                a(class="text-dark") {{ summary.total_po_activity }}

            .col-sm-6.col-md-3.col-xs-12
                .box.p-a
                    .pull-left.m-r
                        i.material-icons.md-36.text-accent.m-y-sm local_shipping
                    .clear
                        .text-muted.text-ellipsis Awaiting Delivery
                        h4.m-a-0.text-md._600
                            v-loading(loader="fetch-summary")
                                a(class="text-dark") {{ summary.total_awaiting_delivery }}

        supply-needs

</template>

<script>
import supplyNeeds from './supply-needs.vue';

export default {
    components: {
        supplyNeeds,
    },

    data() {
        return {
            summary: {
                total_ideal_stock: null,
                total_low_stock: null,
                total_stock_inventory: null,
                total_stock_composite: null,
                total_new_product: null,
                total_check_activity: null,
                total_po_activity: null,
                total_awaiting_delivery: null,
            },
        };
    },

    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    watch: {
        activeOutlet() {
            this.getDashboadSummary();
        },
    },

    async created() {
        await this.getDashboadSummary();

        if (!sessionStorage.returning && this.summary.total_low_stock > 0) {
            this.swal({
                title: 'Low Stock Count',
                type: 'info',
                text:
                    'There are a few stock in low level that need to be restocked',
            });
            sessionStorage.returning = true;
        }
    },

    methods: {
        async getDashboadSummary() {
            this.startLoading('fetch-summary');

            let params = {
                outlet_id: this.activeOutlet,
            };

            try {
                const { data } = await axios.get(
                    Laroute.route('dashboard.summary'),
                    { params },
                );

                this.summary = data;
                this.endLoading('fetch-summary');
            } catch (e) {
                this.summary = data;
                throw e;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/dashboard.vue